import { useEffect } from "react";

export const SITE_URL = "https://www.quantumdesk.com";
export const SITE_NAME = "Quantum Desk";
const DEFAULT_IMAGE = `${SITE_URL}/og-image.jpg`;

const upsert = (selector, attrs) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(attrs.tag || "meta");
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([k, v]) => k !== "tag" && el.setAttribute(k, v));
  el.setAttribute("data-seo", "1");
  return el;
};

const abs = (u) => (!u ? DEFAULT_IMAGE : u.startsWith("http") ? u : `${SITE_URL}${u}`);

export const Seo = ({ title, description, path = "/", image, type = "website", article, jsonLd }) => {
  useEffect(() => {
    const fullTitle = title.includes(SITE_NAME) ? title : `${title} — ${SITE_NAME}`;
    const url = `${SITE_URL}${path}`;
    const img = abs(image);
    document.title = fullTitle;
    upsert('meta[name="description"]', { name: "description", content: description });
    upsert('link[rel="canonical"]', { tag: "link", rel: "canonical", href: url });
    upsert('meta[property="og:type"]', { property: "og:type", content: type });
    upsert('meta[property="og:title"]', { property: "og:title", content: fullTitle });
    upsert('meta[property="og:description"]', { property: "og:description", content: description });
    upsert('meta[property="og:url"]', { property: "og:url", content: url });
    upsert('meta[property="og:image"]', { property: "og:image", content: img });
    upsert('meta[name="twitter:title"]', { name: "twitter:title", content: fullTitle });
    upsert('meta[name="twitter:description"]', { name: "twitter:description", content: description });
    upsert('meta[name="twitter:image"]', { name: "twitter:image", content: img });
    const articleKeys = ["article:published_time", "article:modified_time", "article:author", "article:section"];
    articleKeys.forEach((k) => {
      const v = article?.[k.split(":")[1]];
      const el = document.head.querySelector(`meta[property="${k}"]`);
      if (v) upsert(`meta[property="${k}"]`, { property: k, content: v });
      else el?.remove();
    });
    let ld = document.getElementById("seo-jsonld");
    if (jsonLd) {
      if (!ld) {
        ld = document.createElement("script");
        ld.type = "application/ld+json";
        ld.id = "seo-jsonld";
        document.head.appendChild(ld);
      }
      ld.textContent = JSON.stringify(jsonLd);
    } else ld?.remove();
  }, [title, description, path, image, type, article, jsonLd]);
  return null;
};

export const HOME_SEO = {
  title: "Quantum Desk — Go Agentic. Resolve tickets at $0.79. No seat costs",
  description: "Pay for resolved tickets, not more seats. Prebuy resolutions at $0.79, carry unused credits forward, and try two months free with an agreed resolution allowance.",
  path: "/",
};
